import React from 'react';
import '../styles/visa.css';


const Visa = () => {
    return (
            <div className="visa-content">
                <h2>VISA</h2>
                <p>
                    Vacations are a time for change, adventure, and new experiences. Whether you're exploring exotic locations, meeting fascinating people, or simply soaking in the good times, an international holiday can make your dreams come true. But before you set off on your journey, one crucial step stands between you and your dream destination: obtaining a visa.
                </p>
                <p>
                    A visa is a travel document that conditionally allows you to enter or leave a particular country. It's an essential part of international travel, ensuring that you are legally permitted to enter your chosen destination. By applying for a visa in advance, you give the host country the opportunity to evaluate your financial security, the purpose of your visit, and your travel history.
                </p>
                <p>
                    At <strong>Parth Vacations</strong>, applying for a visa has never been easier. We offer a streamlined, hassle-free visa application process, ensuring you have everything you need to embark on your adventure.
                </p>
                <ul>
                    <li><strong>Convenience:</strong> Apply for your visa online from the comfort of your home.</li>
                    <li><strong>Efficiency:</strong> Our expert team guides you through the process, ensuring all your documents are in order.</li>
                    <li><strong>Support:</strong> We provide assistance every step of the way, from application to approval.</li>
                </ul>
                <p>
                    No matter where your travels take you, Parth Vacations is here to make the visa application process smooth and stress-free. Let us help you unlock the beauty of the world!
                </p>
            </div>
    );
}

export default Visa;
